import { NavItems } from './NavItems';
import { NavSectionHeadingKeys } from './NavSectionHeadingKeys';

export const getNavData = () => ({
  NavItems,
  NavSectionHeadingKeys,
});
